import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=15d9284e&"
import script from "./goodsAdd.vue?vue&type=script&lang=js&"
export * from "./goodsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d9284e')) {
      api.createRecord('15d9284e', component.options)
    } else {
      api.reload('15d9284e', component.options)
    }
    module.hot.accept("./goodsAdd.vue?vue&type=template&id=15d9284e&", function () {
      api.rerender('15d9284e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/queryList/goodsAdd.vue"
export default component.exports